import React from 'react';
import { AdminIdentity } from './../identity/AdminIdentity';

export const checkbrandAuthProvider = {
    // authentication
    login: ({ username, password }: any) => {
        const request = new Request(
            `${process.env.REACT_APP_API_URL}/login`,
            {
                method: 'POST',
                body: JSON.stringify({ email: username, password }),
                headers: new Headers({ 'Content-Type': 'application/json' }),
            }
        );
        return fetch(request)
            .then(async (response) => {
                if (response.status < 200 || response.status >= 300) {
                    const error = await response.json();
                    throw new Error(error && error.Error ? error.Error : response.statusText);
                }
                return response.json();
            })
            .then((auth) => {
                localStorage.setItem(
                    'auth',
                    JSON.stringify( auth )
                );
            })
            .catch((error) => {
                throw new Error(error && error.message && error.message.length > 0 ? error : 'Network error');
            });
    },
    checkError: (error: any) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('auth');
            return Promise.reject();
        }
        // other error code (404, 500, etc): no need to log out
        return Promise.resolve();
    },
    checkAuth: () =>
        localStorage.getItem('auth')
            ? Promise.resolve()
            : Promise.reject({ message: 'login required' }),
    logout: () => {
        localStorage.removeItem('auth');
        return Promise.resolve();
    },
    getIdentity: () => {
        try {
            const identity: AdminIdentity = JSON.parse(localStorage.getItem('auth') || '');
            return Promise.resolve(new AdminIdentity());
        } catch (error) {
            return Promise.reject(error);
        }
    },
    getPermissions: (params: any) => Promise.resolve(),
};